import { faBan, faCheck } from "@fortawesome/free-solid-svg-icons";
import { IPagedListAction } from "../../components/UI/Declarations";
import { RecordLifecycleActionLabels } from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type MdAdminConfirmKind = "disable" | "enable";

export function formatMdToastLabel(
    indicatorType: string | undefined,
    applies: string | undefined
): string {
    const t = typeof indicatorType === "string" ? indicatorType.trim() : "";
    const a = typeof applies === "string" ? applies.trim() : "";
    if (t && a) return `${t} - ${a}`;
    if (t) return t;
    return EntityLabels.municipalDegradableIndicator;
}

export function getMdAdminActionSuccessMessage(
    kind: MdAdminConfirmKind,
    indicatorType: string | undefined,
    applies: string | undefined
): string {
    const label = formatMdToastLabel(indicatorType, applies);
    const successByKind: Record<MdAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
    };
    return successByKind[kind];
}

type MdRow = { id: string; indicatorType: string; applies: string };

export function buildMdAdminPagedListActions(
    openConfirm: (kind: MdAdminConfirmKind, item: MdRow) => void
): IPagedListAction[] {
    return [
        {
            text: RecordLifecycleActionLabels.disable,
            icon: faBan,
            itemClassName: "text-warning",
            onClick: (item: MdRow) => openConfirm("disable", item),
            availableMember: "isActive",
        },
        {
            text: RecordLifecycleActionLabels.enable,
            icon: faCheck,
            itemClassName: "text-warning",
            onClick: (item: MdRow) => openConfirm("enable", item),
            availableMember: "isActive",
            availableFliped: true,
        },
    ];
}
